import { Model } from './Model';
import { ProjectDto } from './Project';

export class ProjectModel 
{
    id!: number;
    participantId!: number;
    foreignId!: string;
    roleId!: string;
    name!: string;
    createdWhen!: string;
    modifiedWhen!: string;
    createdBy!: number;
    modifiedBy!: number;
    description!: string;
    projectForeignKey!: string;
    tenantKey!: string;
    wpo2BimSlug!: string;
    wpo2BimIssueSlug!: string;
    modelDtos!:Model[];
    // projectDtos:Project[];
}

export class BookedProjectModules {
    moduleName: string;
    moduleId: string;
    validUntil: string;

    constructor(moduleName: string, moduleId: string, validUntil: string) {
        this.moduleName = moduleName;
        this.moduleId = moduleId;
        this.validUntil = validUntil;
    }
}